// @flow

import * as React from 'react';
import { connect } from 'react-redux';

import { featureIsEnabled } from '@ta/common.features';
import { Avatar } from '@ta/styleguide.avatar';
import { MemberName, MemberReasonWhy } from '@ta/social.member-common';
import { MemberBio } from '@ta/social.member';
import { Link } from '@ta/common.routing';
import FollowButton from '@ta/social.follow';
import type { MemberInfo, MemberProfile } from '@ta/social.member-types';
import { InteractionLogger } from '@ta/tracking.interactions';

import styles from './FolloweeCardSimple.less';

type ExternalProps = {|
  member: MemberProfile,
  suggestedFolloweesInfo: MemberInfo,
  showBio?: boolean,
|};
type Props = {|
  ...ExternalProps,
  overlay?: ?string,
|};

class FolloweeCardSimple extends React.Component<Props> {
  static defaultProps = { showBio: false };

  shouldComponentUpdate(prevProps: Props) {
    return prevProps.member.isFollowing !== this.props.member.isFollowing;
  }

  render() {
    const { member, suggestedFolloweesInfo, showBio, overlay } = this.props;

    const onboardingOverlay =
      featureIsEnabled('onboarding_suggested_follows_by_interest') &&
      overlay === 'onboarding-interstitial';

    const CardContents = () => (
      <div className={styles.card_container} key={member.displayName}>
        <div>
          <div className={styles.avatar_container}>
            <Avatar photo={member.avatar} size="large" withBorder />
          </div>
          <div className={styles.member_name_container}>
            <MemberName
              profile={member}
              memberInfo={suggestedFolloweesInfo}
              displayNameClassName={styles.display_name}
              usernameClassName={styles.user_name}
              addProfileLink={false}
              singleLine
            />
          </div>
          {showBio && (
            <MemberBio className={styles.bio} truncateLength={60} bio={member.bio} smallText />
          )}
          {suggestedFolloweesInfo?.infoWithMember?.reason && (
            <MemberReasonWhy
              className={styles.reason_why}
              type={suggestedFolloweesInfo.suggestedFolloweeType}
              reason={suggestedFolloweesInfo.infoWithMember.reason}
              singleLine
              lightText
            />
          )}
        </div>
        <div className={styles.follow_button_container}>
          <FollowButton
            profile={member}
            displayType="button+icon"
            // $FlowFixMe: TRVX-14058; this enum isn't a valid enum!
            size="fullwidth small"
            preventClickPropagation
            disableToast={onboardingOverlay}
          />
        </div>
      </div>
    );

    return (
      <InteractionLogger>
        {logUserClick => (
          <React.Fragment>
            {!onboardingOverlay ? (
              <Link
                href={member?.route?.url}
                onClick={e => logUserClick(e, 'userClick', { userId: member.userId })}
              >
                <CardContents />
              </Link>
            ) : (
              <CardContents />
            )}
          </React.Fragment>
        )}
      </InteractionLogger>
    );
  }
}

export default connect<Props, ExternalProps, _, _, _, _>(state => ({
  overlay: state.overlays.global,
}))(FolloweeCardSimple);
